import { useState } from 'react';
import { formatPublishedAt } from '../../../lib/format-date';

export function ArticleAuthorRow({
  url,
  shareUrl,
  title,
  publishedAt,
}: {
  /** Canonical article URL. */
  url: string;
  /** Short link handed to share targets; falls back to the canonical URL. */
  shareUrl?: string;
  title: string;
  publishedAt: string | null;
}) {
  const [copied, setCopied] = useState(false);
  const link = shareUrl ?? url;
  const enc = (s: string) => encodeURIComponent(s);
  const targets = [
    {
      icon: 'fab fa-facebook-f',
      label: 'فيسبوك',
      href: `https://www.facebook.com/sharer/sharer.php?u=${enc(link)}`,
    },
    // WhatsApp carries most news sharing in Morocco and was missing entirely.
    {
      icon: 'fab fa-whatsapp',
      label: 'واتساب',
      href: `https://api.whatsapp.com/send?text=${enc(`${title} ${link}`)}`,
    },
    {
      icon: 'fab fa-telegram',
      label: 'تيليغرام',
      href: `https://www.telegram.me/share/url?url=${enc(link)}&text=${enc(title)}`,
    },
    {
      icon: 'fab fa-twitter',
      label: 'إكس',
      href: `https://www.x.com/intent/post?url=${enc(link)}&text=${enc(title)}`,
    },
    {
      icon: 'fab fa-linkedin',
      label: 'لينكد إن',
      href: `https://www.linkedin.com/shareArticle?url=${enc(link)}&title=${enc(title)}`,
    },
  ];

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard unavailable (insecure context or denied permission). The
      // share buttons still work, so fail quietly rather than alerting.
    }
  }

  return (
    <div className="post-author">
      <div className="author-info">
        <ul>
          <li>
            <time dateTime={publishedAt ?? undefined}>{formatPublishedAt(publishedAt)}</time>
          </li>
        </ul>
      </div>
      <div className="author-social">
        <ul>
          {targets.map((t) => (
            <li key={t.icon}>
              <a
                href={t.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`مشاركة على ${t.label}`}
                title={t.label}
              >
                <i className={t.icon} aria-hidden="true" />
              </a>
            </li>
          ))}
          <li>
            <a
              href={link}
              onClick={(e) => {
                e.preventDefault();
                void copyLink();
              }}
              aria-label="نسخ الرابط"
              title={copied ? 'تم النسخ' : 'نسخ الرابط'}
            >
              <i className={copied ? 'fas fa-check' : 'fas fa-link'} aria-hidden="true" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
